export default {
    "enter_email": "Please enter your email",
    "enter_correct_emali":"Please enter the correct email address",
    "enter_verification_code": "Please enter the verification code",
    "send": "Send",
    "agree_terms_one": "I agree to the ",
    "agree_terms_two": '"User License and Service Agreement"》',
    "agree_terms_three": "and",
    "agree_terms_four": '"Privacy Policy of Digiloong Information Technology (Shanghai) Co., Ltd."',
    "register_login": "Register/Log In",
    "competition_registration": "Registration Questionnaire for the Digiloong GAIC",
    "competition_registration_one":"(\"The Digiloong Cup\" Global AI Innovation Competition) 2026",
    "agreements_notice": "You are required to read the following two agreements:",
    "agreement_3":"and",
    "agreement_1": "\"Participant Agreement of ‘The Digiloong Cup’ Global AI Innovation Competition \"",
    "agreement_2": "\"Personal Information Protection Policy of ‘The Digiloong Cup’ Global AI Innovation Competition \"",
    "read_and_understand": "To protect your legitimate rights and interests, please read and understand all the contents of the above agreements carefully to avoid any omissions.",
    "click_next": "When you click [Next], it means you have agreed to the contents of the agreements.",
    "agree_and_continue": "I have read and agree to the above contents",
    "next": "Next",

    "大陆注登陆/注册 协议":"",
    "enter_phone_number": "Please enter your mobile phone number",
    "enter_correct_phone_number":"Please enter the correct phone number",
    "check_agreement":"Please check the agreement",

    "大陆问卷":"",
    "team_name": "Team Name",
    "team_leader_name": "Contact Person's Name",
    "team_leader_mobile": "Contact Information",
    "team_leader_mobile_type": "(Mobile No./ QQ No./ WeChat ID/ E-mail)",
    "team_leader_mobile_notice": "Note: Please fill in at least one item for online communication.",
    "packaging_instructions_new": "Team Introduction: ",
    // (Attachment Upload) 
    "packaging_instructions_new_type": "(Attachment Upload. Compressed package ≤ 20M)",
    "packaging_instructions_new_notice_one":"Note: ",
    "packaging_instructions_new_notice":"Please package multiple files into one archive for upload. If you upload multiple times, only the last uploaded file will be valid.",
    "work_name":"Product Name",
    "work_type":"Product Type",
    "work_type_one":"Game",
    "work_type_two":"Application",
    "work_description":'Product Introduction',
    "related_materials_baidu": "Product-related Materials",
    // "related_materials_baidu_en": "Related Materials of the Game/Application",
    "related_materials_baidu_en": "Product-related Materials",
    "work_platform":'Applied Awards ',
    // (Multiple choice, max. 3 options)
    "work_platform_type":'(Multiple choice, max. 3 options)',
    "work_platform_one":"Best AI Game Award",
    "work_platform_two":"Best AI Application Award",
    "work_platform_three":"Best Commercial Value Award",
    "work_platform_four":"Best Rookie Award（Priority given to university teams）",
    "work_platform_five":"Best International Team Award（Open only to overseas teams）",
    "art_musicSoundOriginality":'Would you like to synchronously register for the "Cultural and Creative Industry Shanghaii" Smart Future+ Competition?',
    "art_musicSoundOriginality_one":"Yes",
    "art_musicSoundOriginality_two":"No",
    

    "team_leader_qq": "QQ Number of the Team Leader",
    "no_qq_or_wechat": "If you do not have a QQ or WeChat account, please write \"None\" in the corresponding text box.",
    "provide_qq_or_wechat": "Please note: You need to provide at least one of QQ or WeChat so that we can contact you online.",
    "team_leader_wechat": "WeChat Account of the Team Leader",
    "team_leader_email": "Email Address of the Team Leader",
    "team_members_info": "Information of Team Members",
    "packaging_instructions": "Please upload a compressed package containing the following information for all team members (attachment size should not exceed 20MB):",
    "member_info_1": "Name",
    "member_info_2_copy": "Occupation and Company/School (If the occupation is student, please provide the following information)",
    "member_info_2": "Occupation and Company/School",
    "member_info_3": "Major",
    "member_info_4": "Graduation Year",
    "member_info_5": "Student Identity Proof Document",
    "student_proof_requirements": "Regarding student identity proof: Please provide an electronic scan or clear photo of any one of the following documents: China Higher Education Student Information Network (CHESIN) certification report, student ID card, or graduation certificate.",
    "verification_failure": "If the proof document is unclear and we cannot verify the authenticity of the student identity, the registration will be invalid.",
    "game_application_name": "Name of the Game/Application",
    "game_application_type": "Type of the Game/Application",
    "game_application_platforms": "Platforms of the Game/Application",
    "game_application_one": "Console",
    "game_application_two": "Mobile",
    "game_application_three": "Other",
    "game_application_introduction": "Introduction to the Game/Application",
    "originality": "Are the Art/Music/Sound Effects Materials Original?",
    "originality_one": "Fully Original",
    "originality_two": "Partially Original",
    "originality_three": "Not Original",
    "ai_technology_use": "Which Functions of the Game Utilize AI Technology?",

    "related_materials":"Related Materials",
    "executable_file": "Executable file",
    "promotional_posters": "Promotional posters (Optional): One each in 16:9 (horizontal) and 9:16 (vertical) aspect ratios, with the highest possible resolution. These posters will be used for online and offline promotion of the selected works.",
    "video_materials": "Related videos: Including promotional videos and gameplay demonstration videos. These videos will be used for online and offline promotion of the selected works.",
    "other_introduction": "Other introduction materials: Including but not limited to the game/application logo, team logo, and other relevant explanatory documents.",
    "requirement":"Requirements for the Netdisk Link: ",
    "netdisk_requirements": "Classify and package the game/application-related materials, then upload them to Baidu Netdisk. Create a sharing link and set it to be valid permanently.",
    "sharing_link": "Copy and paste the sharing link and extraction code into the box below.",
    "upload_faile":"Upload failed, please try again later", 

    "海外问卷":"",
    "attachment_ask":"Attachment Requirements",
    "attachment_requirements": "Categorize and pack the relevant materials of the game/application, and then upload them to the email address: ai.cht@digiloong.com.",
  
    "sure_submit":'Submit',
    "back":"Cancel",
    "sure_sub_dia":"Are you sure you want to submit?",

    "home":'Home',
    "introduction":"Introduction",
    "schedule":'Schedule',
    "guide":"Guidelines",
    "pane":'Panelists',
    "award":"Awards",
    "news":'News',
    "contact_us":"Contact Us",
    "shulong":"Digiloong365",

    "follow_us":"Follow us", 

    "guid_units":"Guiding Units",
    "games_publishing":"Games Publishing Committee of CADPA",
    "pu_dong":'Pudong New Area Culture, Sports and Tourism Bureau ',
    "pu_culture":"Shanghai Cultural and Creative IndustryPromotion Association",
    "shanghai_online":'Shanghai Online Game Association',
    "macau":"Macau-Qinjin Cultural and Technology Industry Association",

    "strategic_partner":"Strategic Partners",
    "chinaJoy":"ChinaJoy",

    "chief_partnership_park":"Lead Partner Park",
    "shanghai_pudong":"Shanghai Pudong Software Park",

    "chief_in":"Chief Incubator Partners",
    "lighthouse":"Light Source Capital",
    "eastern":"Eastern Bell Capital",
    "chief_financial":"Lead Financial Media Partner",
    "cai_lian":"CLS",

    "chief_media":"Chief Media Partner",   
    "paper":"The Paper",
    "chief_propagation":"Lead Communications Media Partner",
    "chao_news":"TideNews",

    "chief_creative":"Lead VC Media Partner",
    "thirty_six_kr":"36Kr",

    "chief_open_source":"Lead Open Source Community Partner",
    "magic_dabang":"ModelScope",

    "chief_start":"Chief Start-up Partner",
    "shanghai_technology":"Shanghai Technology Entrepreneurship Foundation for Graduates",

    "cooperative_media":"Media Partners",
    "game_inn":"GAMEKEZHAN",
    "game_artist":"GameArt",

    "china_audio":'China Audio-Video and Digital Publishing Association',
    "shanghai_online":"Shanghai Online Game Association",
    "shengqu":"Shengqu Capital",

    "project_incubation":"Incubation Partners",
    "jufan":"FusionHub",
    "pu_soft":"SPSPVC",

    "hold_down":"Hold down the slider and drag",
    "verification":"Please complete security verification",

    "file_size_limit":'The uploaded file size cannot exceed 20MB!',
    "question_complete":"Please fill in the questionnaire information completely",

    "add_determined":"PS：To Be Determined...",
    "up_limit":"The number of file uploads has exceeded the limit",
    "error_time":'Request timed out, please try again later',

    "比赛介绍 ":"",
    "Competition_one":"Digiloong GAIC (The Digiloong Cup Global AI  Innovation Competition) is hosted by ",
    "Competition_two":'Century Huatong',
    "Competition_three":'.  It aims to gather top developers and innovative teams from around the world to explore innovative breakthroughs of AI technology in game development and various application scenarios. The competition is committed to stimulating creativity and promoting technological innovation. It seeks to build a global platform for communication and cooperation, promoting in-depth interaction among the upstream and downstream entities in the industry chain, accelerating the application of AI technology in the gaming field, and driving the prosperity of the AI industry ecosystem.',

    "赛程安排":"",
    "Competition_report":"Application & Preliminary Selection",
    "Competition_report_date":"April 2nd - May 31st",
    "Competition_frist":"First-Round Judging",
    "Competition_frist_date":"June 1st - June 15th", 
    "Competition_se":"Semi-Finalist Selection & Pitch Preparation",
    "Competition_se_date":"June 16th - June 30th",
    "Competition_down":"On-site Finalist Evaluation",
    "Competition_down_date":"Mid-July",
    "Competition_grade":"Grand Finale & Awards Ceremony",
    "Competition_grade_date":"July 31st",

    "参赛须知":"", 
    "Target_audience":"Target Audience",
    "AI_developers":"AI developers, game developers, university students, and enthusiasts worldwide.",
    "Registration_requirements":"Registration Requirements",
    "Requirements_one":"Participants can register individually or as a team but cannot register multiple times. When registering, participants must submit the proof of identity as requested by the organizing committee for verification. ",
    "Requirements_two":"All content submitted by participants, including team and game names, game content, etc., must strictly comply with national laws, regulations, policies, and moral standards. It is strictly forbidden to include content that infringes on third-party intellectual property rights or other legitimate rights and interests. Content involving politics, violence, pornography, personal attacks (including but not limited to insults and defamation), anti-humanity, or blasphemy against religion is prohibited. If any such content is found, the organizer has the right to disqualify the participant and revoke any awarded prizes.",
    "Requirements_three":"Participants must adhere to the principles of fairness and integrity, ensuring the authenticity of their work. It is strictly prohibited to participate in the competition through improper means, such as providing false information or hiring othersto participate on their behalf. If such behavior is verified, the participant's eligibility and any awarded prizes will be immediately revoked.",

    "Work_specifications":"Work Specifications",
    "Work_one":" The work must focus on the practical application of AI in games. During the preliminary screening stage, participants are required to submit a work description document and a demonstration video. In the re-review and offline review stages, the work must be application-oriented and demonstrable.",
    "Work_two":"The work may integrate innovative AI gameplay, AI application scenarios, and technical implementation methods.",
    "Work_three":" If AI-generated assets are used in the work, the participant must clearly mark in the game introduction the statement 'This game includes AI-generated assets' and provide a detailed explanation of the used parts.. If there is any intentional concealment, Century Huatong has the right to disqualify the participant or revoke any awarded prizes. Any copyright disputes arising from the use of AI technology shall be resolved by the participant, who shall bear the corresponding legal  responsibilities.",

    "作品提交":"",
    "Submission":"Submission Process",
    "Submission_des":"Participants must click the button at the top of the page to complete account registration and log in successfully. They must fill in the registration information completely before the specified deadline. Before the deadline for work collection, participants may update and improve their submitted games multiple times. The final submission before the deadline will be considered the official entry.",

    "Copyright":"Copyright of Materials",
    "Copyright_dec":"Participants must ensure that they have the copyright or legal right to use the software and material resources in their work. If open-source resources are used, they must strictly comply with the open-source license. The copyright of the submitted work belongs to the creative team. However, by participating in the competition, participants agree that Century Huatong may use the submitted work free of charge on its related websites and offline activities. Century Huatong commits to strictly protecting the personal information and work information of participants and will not use such information for any other purpose without the consent of the participants.",

    "other":"Other",
    'other_dec':"By submitting a work or registration information, participants are deemed to have irrevocably accepted the above participation guidelines and any related agreements and competition rules issued by Century Huatong from time to time. If the activity cannot proceed normally or participants are unable to participate due to force majeure or other reasons not attributable to Century Huatong, Century Huatong has the right to suspend or cancel the activity without assuming any liability. Within the scope permitted by law, Century Huatong reserves the right to modify and have the final interpretation of the competition rules.",

    "person_one":"JIM Wang",
    "person_one_position":"Century Huatong Chairman",
    "person_two":"Derek Fang",
    "person_two_position":"Century Huatong Chief Strategy Officer",
    
    "person_three":"Tang Jiajun",
    "person_three_position":"世纪华通首席战略官",

    "person_four":"Ding Xiaoling",
    "person_four_position":"世纪华通首席战略官",

    "person_five":"Zhang Qi",
    "person_five_position":"复旦大学计算与智能创新学院",

    "person_six":"Lin Koon Wing, Mac",
    "person_six_position":"世纪华通首席战略官",


    "person_seven":"Yuanlei Niu ",
    "person_seven_position":"点点互动",

    "person_eight":"Xu Hai",
    "person_eight_position":"魔搭社区",

    // "person_nine":"Xinxin Huang",
    // "person_nine_position":"光源资本孵化业务部    高级总监",
    "person_nine":"Ray Mao",
    "person_nine_position":"Neuron Venture Partners Founding Partner",

    // "person_ten":"Wang Zhihao",
    // "person_ten_position":"上海科技创业导师、华政国际知识产权研究中心执行主任 ",

    "person_ten":"暂无",
    "person_ten_position":"上海科技创业导师、华政国际知识产权研究中心执行主任 ",

    "person_ele":"Mike Zhang",
    "person_ele_position":"盛趣游戏技术中心负责人",
    "person_twe":"Tausend Wu",
    "person_twe_position":"盛趣游戏策划中心负责人",

 
    "奖项设置":"",

    "Best_AI":"Best AI Game Award",
    "Awarded_to":"Innovative integration of gameplay and technology",
    "Awarded_to_one":"Grand Prize: 1 winner, ¥50,000",
    "Awarded_to_two":"Nomination Award: 2 winners, ¥20,000 each",

    "Best_tech":"Best AI Application Award",
    "Best_awarded_to":"Product value, user experience, and technical barriers",
    "Best_awarded_to_one":"Grand Prize: 1 winner, ¥50,000",
    "Best_awarded_to_two":"Nomination Award: 2 winners, ¥20,000 each",

    "Best_content":"Most Commercially Viable Award",
    "Best_content_awarded":"Data validation and scalability potential",
    "Best_content_awarded_one":"1 Grand Prize,Bonus ¥50,000",
    "Best_content_awarded_two":"2 Nomination Prizes,Bonus  ¥20,000",

    "Best_audio":"Best Rising Star Award",
    "Best_audio_awarded":"Creative breakthroughs and team potential(Priority given to university teams)",
    "Best_audio_awarded_one":"Grand Prize: 1 winner, ¥30,000",
    "Best_audio_awarded_two":"Nomination Award: 2 winners, ¥10,000 each",

    "Best_visual":"Best OpenClaw Award",
    "Best_visual_awarded":"New Benchmark for AI Agent Practical Operation",
    "Best_visual_awarded_one":"Grand Prize: 1 winner, ¥30,000",

    "Best_rising":"Best International Team Award",
    "Best_rising_awarded":"Innovation capability of overseas teams(Open only to overseas teams)",
    "Best_rising_awarded_one":"Grand Prize: 1 winner, ¥30,000",

    "contact_person_team_name": "Contact Person/Team Name:",
    "region": "Region:",
    "contact_information": "Contact Information: ",
    "contact_information_type": "(Mobile/QQ/WeChat/Email)",
    "openclaw_core_capability": "Your OpenClaw - Core Capability：",
    "openclaw_skill_extension": "Your OpenClaw Skill Extension & Evolution Path",
    "openclaw_security_protection": "Your OpenClaw Security Protection：",
    "openclaw_demo_video": "Your OpenClaw Practical Demo Video (Cloud Disk Link)",
    "video_requirements": "Video Requirements: Clearly demonstrate the full workflow of OpenClaw core capabilities, extended/evolved skills, and security protection.",
    "upload_instructions": "(Please upload all materials to the cloud disk, create a sharing link and set it to be permanently valid.)",
    "other_highlights": "Other Highlights：",











  }